let LegalLinksData = [{
    "title": "Disclaimer",
    "route": "disclaimer"
}, {
    "title": "Copyright Notice",
    "route": "copyright"
}, {
    "title": "Terms & Conditions",
    "route": "terms"
}, {
    "title": "Privacy Policy",
    "route": "privacy"
}, {
    "title": "Security Policy",
    "route": "security"
}, {
    "title": "Cookie Policy",
    "route": "cookie"
}]

export default LegalLinksData
